import React from 'react';
import { SupplementsGuide } from './components/SupplementsGuide';
export function App() {
  return <SupplementsGuide data-id="element-0" />;
}